import classNames from 'classnames'
import { IMedicareCard } from 'models/User'
import { useTranslation } from 'react-i18next'
import { CardImages, CardImageProps } from './CardImages'

type MedicareCardFrontProps = {
  beneficiaryCardData: IMedicareCard
  partAActive: boolean
  partBActive: boolean
}
export const MedicareCardFront = ({
  beneficiaryCardData,
  partAActive,
  partBActive
}: MedicareCardFrontProps) => {
  const { t } = useTranslation('getMyMedicareCardPage')

  const { isImmunosuppressiveDrugCoverage } = beneficiaryCardData

  // To account for PBID flag indicating that as a *future* status, we also check *current* Part A status
  const displayPbid = isImmunosuppressiveDrugCoverage && !partAActive

  // If user has PBID coverage, that supercedes the display of Part B info, though it uses same dates
  const displayPartB = partBActive && !isImmunosuppressiveDrugCoverage

  const cardClasses = classNames(
    'my-c-medicare-card my-c-medicare-card-front',
    {
      'my-c-rrb': beneficiaryCardData.railroadRetirementBoardBeneficiary
    }
  )
  const cardImageProps = ((rrb: boolean): CardImageProps => {
    if (rrb) {
      return {
        topCard: {
          img: 'NewCardTopRRB.png',
          altText: 'Railroad Retirement Board, USA, Medicare Health Insurance'
        },
        bottomCard: {
          img: 'NewCardBottomRRB.png',
          altText: 'Railroad Retirement Board'
        }
      }
    }
    return {
      topCard: {
        img: 'NewCardTop.png',
        altText: 'new card top'
      },
      bottomCard: {
        img: 'NewCardBottom.png',
        altText: 'new card bottom'
      }
    }
  })(beneficiaryCardData.railroadRetirementBoardBeneficiary)

  return (
    <div className="my-c-medicare-card-half">
      <div className={cardClasses}>
        <CardImages {...cardImageProps} />
        <div className="content-padding">
          <div className="ds-l-row my-u-mb--10">
            <div className="ds-l-col--12">
              <div className="my-u-color-label-text">
                <span lang="en">Name</span>/<span lang="es">Nombre</span>
              </div>
              <div className="my-u-color-label-desc ds-u-text-transform--uppercase">
                {/* Do a truthy/falsy check on middlename in case backend data doesn't always contain it like it should */}
                {beneficiaryCardData.firstName}{' '}
                {beneficiaryCardData.middleName?.[0] ?? ''}{' '}
                {beneficiaryCardData.lastName}
              </div>
            </div>
          </div>
          <div className="ds-l-row my-u-mb--5">
            <div className="ds-l-col--12">
              <div className="my-u-color-label-text">
                <span lang="en">Medicare Number</span>/
                <span lang="es">Número de Medicare</span>
              </div>
              <div className="my-u-color-label-desc">
                {beneficiaryCardData.mbi}
              </div>
            </div>
          </div>
          {partAActive || partBActive || isImmunosuppressiveDrugCoverage
            ? (
            <div className="ds-l-row my-u-mb--10">
              <div className="ds-l-col--6">
                <div className="my-u-color-label-text">
                  <span lang="en">Entitled to</span>/
                  <span lang="es">Con derecho a</span>
                </div>
                {displayPbid
                  ? (
                  <div className="my-u-color-label-desc" lang="en">
                    IMMUNO DRUG ONLY
                  </div>
                    )
                  : (
                  <>
                    {partAActive && (
                      <div className="my-u-color-label-desc" lang="en">
                        HOSPITAL (PART A)
                      </div>
                    )}
                    {displayPartB && (
                      <div className="my-u-color-label-desc" lang="en">
                        MEDICAL (PART B)
                      </div>
                    )}
                  </>
                    )}
              </div>
              <div className="ds-l-col--6">
                <div className="my-u-color-label-text">
                  <span lang="en">Coverage starts</span>/
                  <span lang="es">Cobertura empieza</span>
                </div>
                {isImmunosuppressiveDrugCoverage
                  ? (
                  <div className="my-u-color-label-desc">
                    {beneficiaryCardData.partBEffectiveDate}
                  </div>
                    )
                  : (
                  <>
                    {partAActive && (
                      <div className="my-u-color-label-desc">
                        {beneficiaryCardData.partAEffectiveDate}
                      </div>
                    )}
                    {partBActive && (
                      <div className="my-u-color-label-desc">
                        {beneficiaryCardData.partBEffectiveDate}
                      </div>
                    )}
                  </>
                    )}
              </div>
            </div>
              )
            : null}
        </div>
      </div>
      <p className="my-c-medicare-card-title">
        {t('printCardPage.frontOfCard')}
      </p>
    </div>
  )
}
